import { useEffect, useState } from "react";
import { z } from "zod";
import { productionGateway } from "./production-gateway";
const supervisorsSchema=z.array(z.object({id:z.string().min(1),name:z.string().min(1)}));
export function useTerminalSupervisors(terminalCode:string,sessionId:string) {
  const [state,setState]=useState<{scope:string;items:Array<{id:string;name:string}>;error:string|null;loading:boolean}>({scope:"",items:[],error:null,loading:true});
  const [attempt,setAttempt]=useState(0);
  const scope=`${terminalCode}:${sessionId}`;
  useEffect(()=>{
    const controller=new AbortController();
    setState({scope,items:[],error:null,loading:true});
    void productionGateway.terminalSupervisors(terminalCode,controller.signal).then(value=>{
      const items=supervisorsSchema.parse(value);
      if(!controller.signal.aborted)setState({scope,items,error:null,loading:false});
    }).catch(error=>{if(!controller.signal.aborted)setState({scope,items:[],error:error instanceof Error?error.message:"Vardiya amirleri alınamadı.",loading:false});});
    return()=>controller.abort();
  },[scope,terminalCode,attempt]);
  return {...(state.scope===scope?state:{scope,items:[],error:null,loading:true}),retry:()=>setAttempt(value=>value+1)};
}
